import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import Protestos from "../../common/query/Protestos";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import {
  countDadosCadastrais,
  countScore,
  formatDocument,
  getColorScore,
  getImageURLScoreSerasa,
  maskCEP,
} from "../../../utils/utils";
import { useState } from "react";
import { Modal } from "flowbite-react";
import StreetView from "../../common/query/StreetView";
import ModalReceitaFederal from "../../modals/ModalReceitaFederal";
import ScoreRating from "./ScoreRating";

const SpcTerceirosQuery = ({ data, dataFull }) => {
  const [openMap, setOpenMap] = useState(false);

  const fullAddress = [
    data?.dadosCadastrais?.endereco,
    data?.dadosCadastrais?.numero,
    data?.dadosCadastrais?.bairro,
    data?.dadosCadastrais?.cidade,
    data?.dadosCadastrais?.cep,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <>
      <div>
        <TitleStripe>Dados Cadastrais</TitleStripe>

        {data?.dadosCadastrais?.cnpj && (
          <div className="mt-4 grid grid-cols-2 gap-6 bg-white border border-gray-200 rounded-xl p-6 shadow-sm text-sm">
            <div>
              <div className="text-gray-500 text-xs uppercase">
                Razão Social
              </div>
              <div className="font-medium text-gray-900">
                {data?.dadosCadastrais?.razaoSocial || "Indisponível"}
              </div>
              <ModalReceitaFederal cnpj={data?.dadosCadastrais?.cnpj} />
            </div>

            <div>
              <div className="text-gray-500 text-xs uppercase">
                Nome Fantasia
              </div>
              <div className="font-medium text-gray-900">
                {data?.dadosCadastrais?.nomeFantasia || "Indisponível"}
              </div>
            </div>

            <div>
              <div className="text-gray-500 text-xs uppercase">CNPJ/MF</div>
              <div className="font-medium text-gray-900">
                {data?.dadosCadastrais?.cnpj
                  ? formatDocument(data?.dadosCadastrais?.cnpj)
                  : "Indisponível"}
              </div>
            </div>

            <div>
              <div className="text-gray-500 text-xs uppercase">
                CNAE Principal
              </div>
              <div className="font-medium text-gray-900">
                {data?.dadosCadastrais?.ramoAtividade || "Indisponível"}
              </div>
            </div>
          </div>
        )}
      </div>

      {data?.dadosCadastrais?.cpf && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 text-sm border border-gray-200 rounded-xl overflow-hidden">
          {[
            { label: "Nome completo", value: data?.dadosCadastrais?.nome },
            { label: "CPF", value: formatDocument(data?.dadosCadastrais?.cpf) },
            { label: "Origem CPF", value: data?.dadosCadastrais?.regiaoCPF },
            {
              label: "Data de nascimento",
              value: data?.dadosCadastrais?.dataNascimento,
            },
          ].map((item, index) => (
            <div
              key={index}
              className={`p-4 border-b border-gray-200 ${
                (index + 1) % 3 === 0 ? "sm:border-r-0" : "sm:border-r"
              }`}
            >
              <p className="text-gray-500 text-xs mb-1">{item.label}</p>
              {item.isStatus ? (
                <span
                  className={`font-semibold text-sm px-2 py-0.5 rounded-md text-white inline-block ${
                    item.value?.toUpperCase() === "REGULAR"
                      ? "bg-blue-800"
                      : "bg-red-500"
                  }`}
                >
                  {item.value || "Indisponível"}
                </span>
              ) : (
                <p className="font-medium text-gray-800">
                  {typeof item.value === "string"
                    ? item.value?.trim() || "Indisponível"
                    : item.value || "Indisponível"}
                </p>
              )}
            </div>
          ))}
        </div>
      )}

      {dataFull?.scoreRating?.statusRetorno == 1 && (
        <ScoreRating score={dataFull?.scoreRating} block={false} />
      )}
      <div>
        <TitleStripe className="mb-5">II - Pendências Financeiras</TitleStripe>

        {data?.pendenciasFinanceiras?.length > 0 ? (
          <div className="flex gap-2 items-start">
            <div className="flex-1">
              <PendenciasFinanceiras
                quantidadeTotal={data?.resumoConsulta?.serasa?.quantidadeTotal}
                valorTotal={data?.resumoConsulta?.serasa?.valorTotal}
                pendenciasFinanceiras={data?.pendenciasFinanceiras}
              />
            </div>
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-5">III - Restrições Financeiras</TitleStripe>

        {data?.spc?.length > 0 ? (
          <div className="flex gap-2 items-start">
            <div className="flex-1">
              <PendenciasFinanceiras
                quantidadeTotal={data?.resumoConsulta?.spc?.quantidadeTotal}
                valorTotal={data?.resumoConsulta?.spc?.valorTotal}
                pendenciasFinanceiras={data?.spc}
              />
            </div>
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-5">III - Protestos</TitleStripe>

        {data?.protestos?.length > 0 ? (
          <div className="flex gap-2 items-start">
            <div className="flex-1">
              <Protestos
                quantidadeTotal={
                  data?.resumoConsulta?.protestos?.quantidadeTotal
                }
                valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
                protestos={data?.protestos}
              />
            </div>
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <Modal show={openMap} onClose={() => setOpenMap(false)} size="5xl">
        <Modal.Header>Localização</Modal.Header>
        <Modal.Body>
          <div className="space-y-2">
            <div className="text-sm text-gray-600">
              <strong>Endereço:</strong> {fullAddress || "—"}
            </div>
            {fullAddress ? (
              <StreetView address={fullAddress} height={460} />
            ) : (
              <div className="p-3 text-sm text-gray-500">
                Endereço indisponível.
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SpcTerceirosQuery;
